import React from 'react'
import PropTypes from 'prop-types'
import bem from '@argos/utils/esnext/bem'

import SearchIcon from '@argos/icons/esnext/Search/Search'

import './search-bar.scss'

const cn = bem({ prefix: 'ac-', block: 'search-bar' })

class SearchBar extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      searchTerm: props.value,
    }
  }

  submitSearchTerm = (evt) => {
    evt.preventDefault()
    this.props.onSubmit(this.state.searchTerm)
  }

  updateSearchTerm = (evt) => {
    this.setState({
      searchTerm: evt.target.value,
    })
  }

  render() {
    const { large, inverse, cta, hasIcon, onSubmit, value, ...props } = this.props

    const formClass = cn(null, large && 'large')
    const iconClass = cn('icon')
    const inputClass = cn('input', hasIcon && 'icon', 'form-control')
    const buttonClass = cn(
      'button',
      inverse && 'inverse',
      `button ${inverse ? 'button--secondary' : 'button--primary'}`,
    )

    return (
      <form className={formClass} onSubmit={this.submitSearchTerm}>
        {hasIcon && <SearchIcon className={iconClass} fill='#ccc' width={24} height={24} />}
        <input
          className={inputClass}
          value={this.state.searchTerm}
          onChange={this.updateSearchTerm}
          type='text'
          name='search'
          autoComplete='off'
          {...props}
        />
        <button className={buttonClass}>{cta}</button>
      </form>
    )
  }
}

SearchBar.defaultProps = {
  large: false,
  inverse: false,
  hasIcon: true,
  value: '',
  cta: 'Search',
}

SearchBar.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  large: PropTypes.bool,
  inverse: PropTypes.bool,
  hasIcon: PropTypes.bool,
  value: PropTypes.string,
  cta: PropTypes.node,
}

export default SearchBar
